import type { RefKind, RefTarget } from '@heidi/agents/contracts';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useIntl, type IntlShape } from 'react-intl';

import {
  REFERENCE_KINDS,
  type ReferenceCache,
  type ReferenceKind,
} from './chat-object-reference-kinds';

export const readCachedReferenceLabel = (
  cache: ReferenceCache,
  target: RefTarget,
  intl: IntlShape
): string | undefined =>
  (REFERENCE_KINDS[target.kind] as ReferenceKind<RefKind>).cachedLabel(
    cache,
    target,
    intl
  );

/** Names a reference from the cache its chip resolved through, for copied text. */
export const useCachedReferenceLabel = (): ((
  target: RefTarget
) => string | undefined) => {
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useCallback(
    (target: RefTarget) => readCachedReferenceLabel(queryClient, target, intl),
    [queryClient, intl]
  );
};
